<template>
  <div class="header-page">
    <div class="header-left-container">
      <div class="header-logo" @click="goTo()">
        <img src="../assets/img/common/logo_header.svg" alt="">
      </div>
      <!-- <div class="header-describe">
        物联天下，网罗世界，引领工业互联网
      </div> -->
    </div>
    <div class="header-right-container">
       <div style="float:left;    width: 156px;">
          <a
            href="http://124.222.91.72:8081/number_countryside_platform" 
            target="_blank"
            class="jumpLink"
          >
            <div class="logo" style="    position: relative;
    top: 30px;">
              <img src="../assets/img/common/workbench.png" alt />
            </div>
            <div class="text" style="line-height:44px;color:#666;">工作台</div>
          </a>
      </div> 
         
      <div class="already-login-container" v-if="userName" style="float:right;">
        <a href="http://124.222.91.72:8081/number_countryside_platform/" target="_blank" class="operation-btn login-btn">{{ userName }}</a>
      </div>
      <div class="btn-container" v-else style="float:right;">
        <a href="http://124.222.91.72:8081/number_countryside_platform/" target="_blank" class="operation-btn login-btn">登录</a>
        <!-- <a href="javascript:;" class="operation-btn register-btn">注册</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: 'headers',
  data(){
    return {
      userName: '',
    }
  },
  computed: { // 获取vuex的数据
    ...mapState(["isHome"])
  },
  created () {
    this.userName = this.$utils.getStorage("username") ? this.$utils.getStorage("username") : ''
  },
  methods: {
    goTo(){
      this.$router.push({
        name: "index"
      })
    },
    jump( pathName , id ){
      if( id ){
        this.$router.push({
          name: pathName,
          query: {
            id: id,
          }
        })
      }else{
        this.$router.push({
          name: pathName,
        })
      }
    },
  },
}
</script>

<style lang="scss">

</style>
